
import { useCallback } from 'react'
import { Space, Button, Image } from 'antd'
import './style.less'
import { gmapSeachUrl } from '@data/map.js'
import eye from '@images/eye.svg'
import phone from '@images/phone.svg'
import location from '@images/location.svg'
import SVG from 'react-inlinesvg'

const ListItem = (props) => {
  const { store, onClick } = props

  const onListItemClick = useCallback(() => {
    onClick(store)
  }, [store, onClick])

  return (
    <div className="StoreListItem" onClick={onListItemClick}>
      <div className="text-center">
        <SVG className="StoreListItem-eye-icon" src={eye} width="20" title="eye icon" />
      </div>
      <div>
        <div className="StoreListItem-info">
          <span>{store.channel}</span>
          <span> | </span>
          <span>{store.name}</span>
        </div>
        <div className="StoreListItem-phone">{store.phone}</div>
        <div className="StoreListItem-address">{store.address}</div>
      </div>
      <div className="StoreListItem-buttons">
        <Space direction="vertical">
          <Button className="button" type="primary" shape="round" href={`tel:${store.phone}`} icon={<Image width="32px" src={phone} preview={false} />} block>致電門市</Button>
          <Button className="button" type="primary" shape="round" href={gmapSeachUrl(store.address)} icon={<Image width="32px" src={location} preview={false} />} target="blank" block danger>開啟地圖</Button>
        </Space>
      </div>
    </div>
  )
}

export default ListItem